import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Tabs, Tab, CsiImage, Text, TabPanel } from "designSystem/index";
import imageLS from "../images/LandscapeSmallImage.jpg";
import imagePS from "../images/PortraitSmallImage.jpg";

export default () => {
	const defaultTabIndex = 0;

	const [value, setValue] = useState(defaultTabIndex);

	const handleChange = (event: any, newValue: number) => {
		setValue(newValue);
	};

	return (
		<Box textAlign="left">
			<Tabs
				onChange={handleChange}
				value={value}
			>
				<Tab label="Tab 0" />
				<Tab label="Tab 1" />
				<Tab label="Tab 2" />
			</Tabs>
			<TabPanel index={0} selectedTabIndex={value}>
				<Text semiBold text="Content of Tab 0" />
				<CsiImage size="largest" src={imageLS} />
			</TabPanel>
			<TabPanel index={1} selectedTabIndex={value}>
				<Text semiBold text="Content of Tab 1" />
				<CsiImage
					onClick={() => console.log("click")}
					size="largest"
					src={imagePS}
				/>
			</TabPanel>
			<TabPanel index={2} selectedTabIndex={value}>
				<Text semiBold text="Content of Tab 2" />
				<div>
					Lorem Ipsum is simply dummy text of the printing and typesetting industry.
					Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
					when an unknown printer took a galley of type and scrambled it to make a type
					specimen book. It has survived not only five centuries, but also the leap into
					electronic typesetting, remaining essentially unchanged. It was popularised in
					the 1960s with the release of Letraset sheets containing Lorem Ipsum passages,
					and more recently with desktop publishing software like Aldus PageMaker including
					versions of Lorem Ipsum.
				</div>
			</TabPanel>
		</Box>
	);
};


